import React, {useEffect, useState} from 'react';
import panelStyles from "components/homePanels/Panels.module.scss";
import {useSelector} from "react-redux";

const BackGround = React.forwardRef((props, ref) => {

    const windowData = useSelector(state => state.window);
    const [imageSrc, setImageSrc] = useState();

    useEffect(()=>{

        let set = {...props.set}
        let sizeFound = false;
        let sourceFound = set['default'];
        delete set['default'];

        for (let [key, value] of Object.entries(set)) {
            if(!sizeFound && windowData.width < parseInt(key)) {
                sizeFound = true;
                sourceFound = value;
            }
        }

        if(sourceFound !== imageSrc && windowData.increase) setImageSrc(sourceFound);

    }, [windowData,imageSrc,props.set])

    function loadBackground(){

        let style = {backgroundImage: `url(${imageSrc})`};
        if(props.cover){
            style.backgroundSize = 'cover';
            style.backgroundPosition = 'center';
        }

        if(imageSrc){
            let attrs = {...props};
            delete attrs.cover;
            return (
                <div ref={ref} className={`${panelStyles.backGround}`} {...attrs}
                     style={style}/>
            )
        } else return <></>
    }

    return loadBackground();

});

export default BackGround
